
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/canpar",
      function () {
        return require("private-next-pages/partners/canpar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/canpar"])
      });
    }
  